import Datagrid from "./datagrid/Datagrid.vue";
import DeleteListingItem from "./basic/DeleteListingItem.vue";

Vue.component('datagrid', Datagrid);
Vue.component('delete-listing-item', DeleteListingItem)



// WEBPACK FOOTER //
// ./resources/assets/admin/js/components/index.js